import { useEffect, useState } from 'react';
import { Layout } from '../components/Layout';
import { Card } from '../components/ui';
import { CopyBlock, brandTagSnippet, DEFAULT_BRAND, type BrandConfig } from '../components/ImplementationCode';
import { api } from '../lib/api';
import type { ApiResponse } from '../lib/types';

// Cores por posição — marcas dinâmicas ganham as próximas do ciclo
const COLORS = ['#3498db', '#e74c3c', '#9b59b6', '#16a085', '#e67e22', '#2c88d9'];

export default function Implementation() {
  const [brands, setBrands] = useState<BrandConfig[]>([DEFAULT_BRAND]);

  useEffect(() => {
    api.get<ApiResponse<BrandConfig[]>>('/whitelabel/brands')
      .then((r) => { if (r.data?.length) setBrands(r.data); })
      .catch(() => {});
  }, []);

  return (
    <Layout title="Implementation Codes">
      <Card className="p-6">
        <p className="text-sm text-slate-600 mb-6">
          Use the code below to implement campaigns on your website. Replace <code className="bg-surface-muted px-1 rounded">{'{campaignId}'}</code> with the actual campaign ID.
          Brands provisioned in Settings → White-label Domains appear here automatically.
        </p>
        {brands.map((b, i) => (
          <div key={b.label} className="mb-8">
            <h4 className="text-base font-semibold mb-1 flex items-center gap-2" style={{ color: COLORS[i % COLORS.length] }}>
              &lt;/&gt; {b.label.charAt(0).toUpperCase() + b.label.slice(1)} Implementation
              {!b.builtin && <span className="text-[10px] font-medium uppercase tracking-wide rounded-full bg-emerald-100 text-emerald-700 px-2 py-0.5">dynamic</span>}
            </h4>
            <p className="text-xs text-slate-400 mb-3 font-mono">{b.script_url} · {b.function_name}() · {b.campaign_param}/{b.user_param}</p>
            <Card className="p-4">
              <CopyBlock code={brandTagSnippet(b)} />
            </Card>
          </div>
        ))}
      </Card>
    </Layout>
  );
}
